import styles from "./FormContainer.module.css";

const FormContainer = (props) => {
  return <div className={styles.container} {...props} />;
};

export default FormContainer;
